module.exports = __webpack_public_path__ + "static/media/calculatorimage_mouseover.e450a299.png";